import { Button, Modal } from 'antd'
import React from 'react'

interface DeletModalProps {
  id: string
  visible: boolean
  onClose: () => void
  title: string
  onDelete: (id: string) => void
}

const DeleteModal: React.FC<DeletModalProps> = ({ id, visible, onClose, onDelete, title }) => {
  const handleDelete = () => {
    onDelete(id)
    onClose()
  }

  return (
    <Modal
      title={title}
      open={visible}
      onCancel={onClose}
      footer={[
        <Button key="back" onClick={onClose}>
          İptal
        </Button>,
        <Button key="submit" type="primary" danger onClick={handleDelete}>
          Sil
        </Button>,
      ]}
    >
      <p>Silmek istediğinizden emin misiniz?</p>
    </Modal>
  )
}

export default DeleteModal
